const NAME = "POSITION_EDITOR";

export default NAME;
